import { reportDataGQLFields } from './reportData.fields.js';
const BASIC_REPORT_FIELDS = {};
const ALL_REPORT_FIELDS = {
    data: 'basic',
};
export function reportGQLFields(fields) {
    if (fields === 'basic')
        fields = BASIC_REPORT_FIELDS;
    if (fields === 'all')
        fields = ALL_REPORT_FIELDS;
    return `
    description
    endDate
    previousValue
    slug
    startDate
    title
    tooltip
    value
    ${fields.data
        ? `
      data {
        ${reportDataGQLFields(fields.data)}
      }
    `
        : ``}
  `;
}
